import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import {
  SHIPPING_PROVIDER,
  SHIPPING_STATUS,
} from '../../constants/shipping-status'
import { AllowShippingProviderLists } from '../../utils/provider'
import { useUser } from '../../hooks/useUser'
import { ImageLinks, LogoTypeProvider } from '../../constants/image-link'

interface Props {
  onFilterChange: (filter: any) => void
  filter: any
  col?: number
}

const FilterShippings = (props: Props) => {
  const { onFilterChange, filter, col = 6 } = props
  const { trackingProvider } = filter
  const { merchant } = useUser()

  const getProviderStatusOptions = () => {
    const provider = SHIPPING_STATUS.find(
      (p) => p.provider === trackingProvider,
    )
    return provider ? provider.status : []
  }

  const disabled = trackingProvider && trackingProvider !== 'all'

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} lg={col}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="trackingProvider-label">ช่องทางการขนส่ง</InputLabel>
            <Select
              id="trackingProvider"
              name="trackingProvider"
              labelId="trackingProvider-label"
              value={filter.trackingProvider || ''}
              onChange={(e) =>
                onFilterChange({
                  ...filter,
                  trackingProvider: e.target.value as SHIPPING_PROVIDER,
                })
              }
              fullWidth
            >
              <MenuItem disabled value="" selected>
                <em>ช่องทางการขนส่ง</em>
              </MenuItem>
              <MenuItem value="all" key="all">
                ทั้งหมด
              </MenuItem>
              {AllowShippingProviderLists(merchant).map(
                (item, index: number) => (
                  <MenuItem value={item.value} key={index}>
                    {item.value !== 'all' && (
                      <img
                        style={{ marginRight: 5 }}
                        src={
                          ImageLinks[
                            `LOGO_${item.value.toUpperCase()}` as LogoTypeProvider
                          ]
                        }
                        alt="smallLogoSocial"
                        height={20}
                      />
                    )}
                    {item.label}
                  </MenuItem>
                ),
              )}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} lg={col}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="providerStatus-label">สถานะการขนส่ง</InputLabel>
            <Select
              disabled={!disabled}
              id="providerStatus"
              name="providerStatus"
              labelId="providerStatus-label"
              value={filter.providerStatus || ''}
              onChange={(e) =>
                onFilterChange({
                  ...filter,
                  providerStatus: e.target.value as SHIPPING_PROVIDER,
                })
              }
              fullWidth
            >
              <MenuItem disabled value="" selected>
                <em>สถานะการขนส่ง</em>
              </MenuItem>
              <MenuItem value={'all'}>ทั้งหมด</MenuItem>
              {getProviderStatusOptions().map(
                (
                  item: {
                    code: number | string
                    name: string
                    status: string
                  },
                  index: number,
                ) => (
                  <MenuItem value={item.code} key={index}>
                    {item.name}
                  </MenuItem>
                ),
              )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
export default FilterShippings
